export default "__VITE_ASSET__BPOifdo$__"